import { useContext } from 'react'
import { SUPPORT_NFTS } from 'config/constants/supportChains'
import Staking from 'views/Nft/staking'
import { NFT_STAKING_TYPE } from 'config/constants/types'

const StakingPage = () => {
  return (<Staking type={NFT_STAKING_TYPE.PARTNER} />)
}

StakingPage.chains = SUPPORT_NFTS

export default StakingPage
